var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawalRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 122.88 79.03",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.67,9.74v69.28H34.21V9.74H14.5c-2.17,0-3.6,1.57-4.27,3.58c-0.33,0.98-0.49,2.1-0.49,3.27     c0,1.17,0.16,2.29,0.49,3.27c0.67,2.01,2.1,3.58,4.27,3.58h7.48c2.69,0,4.87,2.18,4.87,4.87s-2.18,4.87-4.87,4.87H14.5     c-7.08,0-11.56-4.51-13.48-10.28C0.34,20.86,0,18.7,0,16.59c0-2.11,0.34-4.27,1.02-6.32C2.94,4.51,7.42,0,14.5,0h93.87     c7.08,0,11.56,4.51,13.48,10.28c0.68,2.05,1.02,4.21,1.02,6.32c0,2.11-0.34,4.27-1.02,6.32c-1.92,5.77-6.4,10.28-13.48,10.28     h-9.41c-2.69,0-4.87-2.18-4.87-4.87s2.18-4.87,4.87-4.87h9.41c2.17,0,3.6-1.57,4.27-3.58c0.33-0.98,0.49-2.1,0.49-3.27     c0-1.17-0.16-2.29-0.49-3.27c-0.67-2.01-2.1-3.58-4.27-3.58H88.67z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalRequest);
export default __webpack_public_path__ + "static/media/withdrawal_request.0d807c8fc970ee729988a8d6c6af5414.svg";
export { ForwardRef as ReactComponent };